// @flow
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Components
import Select from 'Common/Select';
import Input from 'Common/Input';

// Helpers
import classNames from 'classnames';

import { withinDistanceValues } from 'Common/filterValues';

import {
  getPriceFromValues,
  getPriceToValues
} from 'Common/calculatePriceIncrements';

import { getKey } from 'Common/formValues';

/**
 * <BasicFilters /> component.
 * @return {class} returns basicfilters instance
 */
class BasicFilters extends PureComponent<*, *> {
  /**
   * @param {object} props - props passed
   */
  constructor(props: Object) {
    super(props);
    this.state = {
      modelSelectStatus: true
    };
  }

  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {string} topRowClasses - topRowClasses.
   * @prop {object} styles - styles.
   * @prop {object} bootstrap - bootstrap.
   * @prop {array} makes - makes.
   * @prop {array} models - models.
   * @prop {function} checkPostcode - checkPostcode.
   * @prop {number} priceFrom - priceFrom.
   * @prop {number} priceTo - priceTo.
   * @prop {object} fields - fields.
   * @prop {function} resetField - resetField.
   */
  static propTypes = {
    topRowClasses: PropTypes.string.isRequired,
    styles: PropTypes.object.isRequired,
    bootstrap: PropTypes.object.isRequired,
    makes: PropTypes.array,
    models: PropTypes.array,
    checkPostcode: PropTypes.func.isRequired,
    fields: PropTypes.object.isRequired,
    isPostcodeValid: PropTypes.bool.isRequired,
    priceFrom: PropTypes.number,
    priceTo: PropTypes.number,
    resetField: PropTypes.func,
    isResultsLoading: PropTypes.bool,
    setPostcodeRef: PropTypes.func,
    highlight: PropTypes.bool
  };

  showModels = () => !this.props.fields.make;

  showDistances = () => !this.props.fields.postCode;

  handleChange = () => {
    this.setState({ modelSelectStatus: true });
  };

  /**
   * componentDidUpdate - set modelSelectStatus to false only when a new make is selected and the results is loading
   * @param {object} prevProps - previous props
   * @return {void}
   */
  componentDidUpdate(prevProps) {
    if (
      (this.props.isResultsLoading !== prevProps.isResultsLoading ||
        this.props.fields.make !== prevProps.fields.make) &&
      this.state.modelSelectStatus
    ) {
      !this.showModels() &&
        this.props.isResultsLoading &&
        this.setState({ modelSelectStatus: false });
    }
  }

  /**
   * Renders <BasicFilters /> component.
   *
   * @return {JSX} - renders a logo.
   */
  render() {
    const {
      topRowClasses,
      styles,
      bootstrap,
      makes,
      models,
      checkPostcode,
      fields,
      isPostcodeValid,
      priceFrom,
      priceTo,
      resetField,
      isResultsLoading
    } = this.props;

    const { modelSelectStatus } = this.state;

    return (
      <div className={topRowClasses}>
        <div className={classNames(styles.formRowItem)}>
          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'make'}
            label={'Select make (any)'}
            options={makes}
            selectedValue={fields.make}
            resetField={resetField}
            isDisabled={isResultsLoading}
            onChange={this.handleChange}
          />
        </div>

        <div className={classNames(styles.formRowItem)}>
          <Select
            styles={styles}
            bootstrap={bootstrap}
            name={'model'}
            label={'Select Model (any)'}
            options={models}
            selectedValue={fields.model}
            isDisabled={
              modelSelectStatus || this.showModels() || isResultsLoading
            }
          />
        </div>

        <div className={classNames(styles.formRowItem)}>
          <div className={classNames(styles.doubleSelect)}>
            <Select
              styles={styles}
              bootstrap={bootstrap}
              name={'cashPriceFrom'}
              label={'Price from'}
              options={getPriceFromValues(
                priceFrom,
                priceTo,
                getKey(fields.cashPriceTo)
              )}
              selectedValue={fields.cashPriceFrom}
              disableCount={true}
              borderRight={true}
              isPrice={true}
              isDisabled={isResultsLoading}
            />

            <Select
              styles={styles}
              bootstrap={bootstrap}
              name={'cashPriceTo'}
              label={'Price to'}
              options={getPriceToValues(
                priceFrom,
                priceTo,
                getKey(fields.cashPriceFrom)
              )}
              selectedValue={fields.cashPriceTo}
              disableCount={true}
              isPrice={true}
              isDisabled={isResultsLoading}
            />
          </div>
        </div>

        <div className={classNames(styles.formRowItem)}>
          <div
            className={classNames(styles.doubleSelect, styles.fullWidthMobile)}
          >
            <Input
              styles={styles}
              bootstrap={bootstrap}
              name={'postCode'}
              label={'Postcode'}
              onChangeHandler={checkPostcode}
              // onBlurHandler={this.gtmPushPostcode}
              selectedValue={fields.postCode}
              showIcon={true}
              placeholderText={'Postcode'}
              isValid={isPostcodeValid}
              errorMessage={'Please enter a valid UK postcode'}
              isLoading={isResultsLoading}
              resetField={this.props.resetField}
              setRef={this.props.setPostcodeRef}
              highlight={this.props.highlight}
            />

            <Select
              styles={styles}
              bootstrap={bootstrap}
              name={'withinDistance'}
              label={'Distance'}
              options={withinDistanceValues}
              selectedValue={fields.withinDistance}
              isDisabled={!fields.isPostCodeValid}
              disableCount={true}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default BasicFilters;



// WEBPACK FOOTER //
// ./src/Home/BasicFilters/index.js